import { createStore } from "redux";

const today = new Date();
const todayDate = String(today.getMonth() + 1).padStart(2, '0') + '/' + String(today.getDate()).padStart(2, '0') + '/' + today.getFullYear();

const packageJson = require('../package.json');

const initialState = {
	version: packageJson.version,
	apiServer: 'https://api.gldstools.com/index.php',
	agent: '',
	weekstart: 0,
	errorMessage: [],
	errorMessageModal: false,
	userLoggedIn: false,
	username: '',
	uid: '',
	session: '',
	isAdmin: 'N',
	view: 'ReportList',
	period: 'today',
	periodType: 'D',
	periodDateStart: todayDate,
    periodDateEnd: todayDate,
	dept_tab: [],
	sdp_tab: [],
	tlz_tab: [],
    lastWeekColor: "#198722",
    thisWeekColor: "#578AC8"
    
};

const rootReducer = function(state = initialState, action){
	let newState = {...state};
	switch(action.type){
		case 'errorMessage':
			
			if(action.errorMessage === ''){
				newState['errorMessage'] = [];
			}
			else{
				if(Array.isArray(state['errorMessage'])){
					newState['errorMessage'] = state['errorMessage'].concat(action.errorMessage);
				}
				else{
					newState['errorMessage'] = new Array(action.errorMessage);
				}
			}
			newState['errorMessageModal'] = action.errorMessageModal;
			return newState;
		case 'loginUser':
			
			newState['errorMessage'] = '';
			newState['userLoggedIn'] = true;
			newState['username'] = action.username;
			newState['uid'] = action.uid;
			newState['session'] = action.session;
			newState['isAdmin'] = action.isAdmin;
			return newState;
		case 'logoutUser':
			
			return initialState;
		case 'setAgent':
			
			newState['agent'] = action.agent;
			newState['weekstart'] = action.weekstart;
			return newState;
		case 'setPeriod':
		
			newState['period'] = action.period;
			newState['periodType'] = action.periodType;
			newState['periodDateStart'] = action.periodDateStart;
            newState['periodDateEnd'] = action.periodDateEnd;
			return newState;
		case 'setDepartments':
			
			newState['dept_tab'] = action.dept_tab;
			return newState;
		case 'setSubDepartments':
			
			newState['sdp_tab'] = action.sdp_tab;
			return newState;
		case 'setTotalizers':
			
			newState['tlz_tab'] = action.tlz_tab;
			return newState;
		case 'setOperators':
			
			newState['clk_tab'] = action.clk_tab;
			return newState;
		case 'setCategories':
			
			newState['cat_tab'] = action.cat_tab;
			return newState;
		case 'setFamilyCodes':
			
			newState['fam_tab'] = action.fam_tab;
			return newState;
		case 'setReportCodes':
			
			newState['rpc_tab'] = action.rpc_tab;
			return newState;
		case 'showView':
			
			newState['view'] = action.view;
			return newState;
        case 'setChartColor':
            
            newState['lastWeekColor'] = action.lastWeekColor;
            newState['thisWeekColor'] = action.thisWeekColor;
            return newState;
		case 'resetState':
			return initialState;
		default:
	
			return newState;
	}
}

export default createStore(rootReducer);
